// Make sure to prefix the mutation names with the module to avoid collisions
export const DISCUSSION_CATEGORY_MODAL_OPEN = 'discussionCategoryModalOpen'
export const DISCUSSION_CATEGORY_MODAL_CLOSE = 'discussionCategoryModalClose'

export const DISCUSSION_ARCHIVE_POST_MODAL_OPEN = 'discussionArchivePostModalOpen'
export const DISCUSSION_ARCHIVE_POST_MODAL_CLOSE = 'discussionArchivePostModalClose'

export const DISCUSSION_ARCHIVE_REPLY_MODAL_OPEN = 'discussionArchiveReplyModalOpen'
export const DISCUSSION_ARCHIVE_REPLY_MODAL_CLOSE = 'discussionArchiveReplyModalClose'

// Category Listing
export const DISCUSSION_SET_CATEGORIES = 'discussionSetCategories'

// Category
export const DISCUSSION_SET_CATEGORY = 'discussionSetCategory'
export const DISCUSSION_ADD_CATEGORY = 'discussionAddTOCategories'
export const DISCUSSION_REMOVE_CATEGORY = 'discussionRemoveFromCategories'

//Post Listing
export const DISCUSSION_SET_POSTS = 'discussionSetPosts'
export const DISCUSSION_SET_ARCHIVED_POSTS = 'discussionSetArchivedPosts'
//Post
export const DISCUSSION_SET_POST = 'discussionSetPost'
export const DISCUSSION_REMOVE_POST = 'discussionRemovePost'
export const DISCUSSION_ADD_POST = 'discussionAddPost'

//Reply Listing
export const DISCUSSION_SET_REPLIES = 'discussionSetReplies'

//Reply
export const DISCUSSION_SET_REPLY = 'discussionSetReply'
export const DISCUSSION_REMOVE_REPLY = 'discussionRemoveReply'
export const DISCUSSION_ADD_REPLY = 'discussionAddReply'